import { Tag } from "antd";

export interface FilterChip {
	key: string;
	label: string;
}

interface Props {
	chips: FilterChip[];
	onRemove: (key: string) => void;
	/** Olib tashlash tugmasining `aria-label` i (tarjima qilingan). */
	removeLabel: (chip: FilterChip) => string;
}

/**
 * Faol filtr chiplari.
 *
 * ⚠️ Yopish — antd `closable` EMAS, ichki `<button>`: u `aria-label`
 * bilan nomlanadi va klaviaturadan bosiladi (antd yopish belgisi
 * nomsiz `span`).
 */
export function FilterChips({ chips, onRemove, removeLabel }: Props) {
	if (chips.length === 0) {
		return null;
	}

	return (
		<div data-testid="filter-chips" className="flex flex-wrap items-center gap-1.5">
			{chips.map((chip) => (
				<Tag key={chip.key} data-chip={chip.key} className="!m-0 inline-flex items-center gap-1">
					<span>{chip.label}</span>
					<button
						type="button"
						aria-label={removeLabel(chip)}
						className="cursor-pointer border-0 bg-transparent p-0 leading-none opacity-60 hover:opacity-100"
						onClick={() => onRemove(chip.key)}
					>
						×
					</button>
				</Tag>
			))}
		</div>
	);
}
